import { useState } from "react";
import { Stack } from "@mui/material";
import { IDevice } from "../../devices/types";
import { TAndCondition, TCondition, TOrCondition } from "./types";
import ConditionForm from "./ConditionForm";
import React from "react";

type TLogicalCondition = TAndCondition | TOrCondition;

interface ILogicalConditionFormProps<T> {
  condition: T;
  devices: IDevice[];
  device_id: number | undefined;
  attribute: string | undefined;
  onChange: (andCondition: T) => void;
}

const LogicalConditionForm = <T extends TLogicalCondition,>(props: ILogicalConditionFormProps<T>) => {
  const { condition, devices, device_id, attribute, onChange } = props;
  const [condition1, setCondition1] = useState<TCondition>(
    condition.conditions[0]
  );
  const [condition2, setCondition2] = useState<TCondition>(
    condition.conditions[1]
  );

  const [andCondition, setAndCondition] = useState<T>({
    ...condition,
    conditions: [condition1, condition2],
  });

  const updateAndCondition = (newAndCondition: T) => {
    setAndCondition(newAndCondition);
    onChange(newAndCondition);
  };

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{ paddingLeft: "5%", width: "95%" }}
    >
      <ConditionForm
        condition={andCondition.conditions[0]}
        devices={devices}
        device_id={device_id}
        attribute={attribute}
        onChange={(condition: TCondition) => {
          setCondition1(condition);
          updateAndCondition({
            ...andCondition,
            conditions: [condition, condition2],
          });
        }}
      />
      <ConditionForm
        condition={andCondition.conditions[1]}
        devices={devices}
        device_id={device_id}
        attribute={attribute}
        onChange={(condition: TCondition) => {
          setCondition2(condition);
          updateAndCondition({
            ...andCondition,
            conditions: [condition1, condition],
          });
        }}
      />
    </Stack>
  );
};

export const AndConditionForm = LogicalConditionForm<TAndCondition>;
export const OrConditionForm = LogicalConditionForm<TOrCondition>;
